export enum WorkflowSchemaActionStateItemAvailability {
    BeforeExecution = 1,
    AfterExecution = 2,
}
